import React from 'react';
import DeleteModal from "../../../../Modals/DeleteModal";
import CustomTable from "../../../../../components/table/CustomTable";
import {permissionObj} from "../../../../../Helpers/permission";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import ControllerTableApp from "../Functionality/ControllerTableApp";
import CustomButtonLink from "../../../../../components/buttons/CustomButtonLink";
import routes from "../../../../../Routes/routes";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const ControllerTable = (props) => {
    const {
        deleteControllerShow,
        setDeleteControllerShow,
        setSearch,
        option,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setSimpleSearch,
        selectedList,
        setSelectedList
    } = props;
    const {
        t,
        DEV,
        permission,
        navigate,
        rowsPerPage,
        contractorId,
        supplierId,
        tableId,
        searchId,
        thead,
        tbody,
        setResults,
        isAllChecked,
        deletePermission,
        handleDeleteAll,
        handleCheckboxChange,
        getActionsButtons,
        deleteSelectedController,
        pagination
    } = ControllerTableApp({
        option,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setSimpleSearch,
        selectedList,
        setSelectedList
    });

    return (
        <>
            <SearchSimple
                id={"txt_cnt_search_simple"}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                contractorId={contractorId}
                supplierId={supplierId}
                setSimpleSearch={setSimpleSearch}
                setSearch={setSearch}
            />

            <CustomTable tableId={tableId}
                searchId={searchId}
                checkbox={deletePermission}
                checkboxTitle={"de_/_select_all"}
                isAllChecked={isAllChecked}
                onChangeCheckbox={handleDeleteAll}
                thead={thead}
                tbody={tbody}
                columnActions={(DEV || permission?.includes(permissionObj?.WEB_HID_UPDATE))}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectedList}
                getActionsButtons={getActionsButtons}
                childrenNotInformation={tbody?.data?.length === 0 ? <>
                     <div className={"warning-text"}>
                         <p>{t("you_haven_not_created_any_controller_yet")}</p>
                     </div>
                     { (DEV || permission?.includes(permissionObj?.WEB_HID_CREATE)) &&
                     <CustomButtonLink splitName={false} id={'btn_ct_create'} card={true}
                                       onClick={() => navigate(routes.controller.create)}
                                       name={'create_new_controller'}/>
                     } </>
                 : undefined
                }
            />

            {pagination()}

            <DeleteModal
                show={deleteControllerShow}
                onHide={() => setDeleteControllerShow(false)}
                onClickFn={() => deleteSelectedController(selectedList)}
                data={selectedList}
                title_modal={t('delete_controller')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('controller_s')}
            />
        </>
    );
};

export default ControllerTable;
